module.exports = __webpack_public_path__ + "img/Group_white.7238b6ac.svg";